/* eslint-disable complexity */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bool, func, number, string } from 'prop-types';
import { t } from 'i18next';

import { DISPATCH_METHOD_TARGET } from '~redux/SearchStore/constants';
import { actionCreators as homeActions } from '~screens/Dashboard/screens/Home/redux/actions';

import styles from './styles.module.scss';
import TipIcon from './components/TipIcon';
import TipAmountSelection from './components/TipAmountSelection';
import useTipSelection from './hooks';

function TipSelection({
  selectedPaymentMethod,
  isPapaCar,
  dispatchMethod,
  subtotal,
  resetTip,
  noCustomTip = false
}) {
  const [index, setIndex] = useState('without-tip');

  const { showTipModule, disableTips } = useTipSelection({
    selectedPaymentMethod,
    isPapaCar,
    dispatchMethod
  });

  useEffect(() => {
    if (disableTips) {
      resetTip();
    }
  }, [disableTips]);

  const handleSetIndex = innerIndex => {
    setIndex(innerIndex);
  };

  return (
    <>
      {showTipModule && (
        <div className={styles.containerTips}>
          <div className={`${styles.containerTextTips} row middle`}>
            <div className="row full-width">
              <TipIcon index={index} />
              <span className={styles.textAddTipMessage}>{t('TipSelection:addTip')}</span>
            </div>
          </div>
          <div className={`row middle full-width ${styles.tipsContainer}`}>
            <TipAmountSelection
              className={styles.tipAmountContainer}
              onSetIndex={handleSetIndex}
              subtotal={subtotal}
              onResetTip={resetTip}
              noCustomTip={noCustomTip}
            />
          </div>
        </div>
      )}
    </>
  );
}

TipSelection.propTypes = {
  resetTip: func.isRequired,
  dispatchMethod: string,
  isPapaCar: bool,
  noCustomTip: bool,
  selectedPaymentMethod: string,
  subtotal: number
};

const mapStateToProps = state => ({
  dispatchMethod: state.searchStore[DISPATCH_METHOD_TARGET],
  subtotal: state.home.shoppingCart.subtotal
});

const mapDispatchToProps = dispatch => ({
  resetTip: () => dispatch(homeActions.resetTip())
});

export default connect(mapStateToProps, mapDispatchToProps)(TipSelection);
